import { Box } from "@mui/material";
import React, { useRef } from "react";

import { CanvasRef } from "features/canvas/Canvas";
import { Modal } from "new-components/modals/Modal";
import { CanvasAnnotation } from "types/imageAnnotations";

import { ImageAnnotator } from "./ImageAnnotator/ImageAnnotator";

type ImageAnnotatorModalProps = {
  imageUrl: string | null;
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  onSaveAnnotatedImage: (image: File) => void;
  annotations: CanvasAnnotation[];
  setAnnotations: React.Dispatch<React.SetStateAction<CanvasAnnotation[]>>;
};

export function ImageAnnotatorModal({
  imageUrl,
  open,
  onClose,
  onCancel,
  onSaveAnnotatedImage,
  setAnnotations,
  annotations,
}: ImageAnnotatorModalProps) {
  const canvasRef = useRef<CanvasRef | null>(null);
  const blurAnnotations = () => {
    canvasRef.current?.blurAnnotations();
  };

  return (
    <Modal
      title="Edit image"
      titleAlignment="left"
      open={open}
      onClose={onClose}
      onCancel={onCancel}
      confirmationButtonTitle="Add image"
      onConfirmation={async () => {
        const annotatedImage = await canvasRef.current?.generateImage();

        if (annotatedImage) {
          onSaveAnnotatedImage(annotatedImage);
        }
      }}
      body={
        imageUrl ? (
          <Box width="100%" height="440px" sx={{ padding: "20px 0px" }}>
            <ImageAnnotator
              ref={canvasRef}
              imageUrl={imageUrl}
              setAnnotations={setAnnotations}
              annotations={annotations}
              blurAnnotations={blurAnnotations}
            />
          </Box>
        ) : null
      }
    />
  );
}
